<template>
  <div class="filter-multiple" v-if="types">
    <div
      v-for="(type, index) in types"
      :key="type.shortTitle"
      class="filter-multiple__item"
      :class="{ active: isActive(index) }"
      @click="setSelected(index)"
    >
      {{ type.title }}
    </div>
  </div>
</template>

<script>
import { courseTypeList } from '@/modules/course-type-list.js'

export default {
  name: 'CourseTypeFilter',
  model: {
    prop: 'currentType'
  },
  props: {
    currentType: {
      type: Number,
      required: false
    }
  },
  data: () => ({}),
  computed: {
    types() {
      return courseTypeList
    }
  },
  methods: {
    isActive(type) {
      return this.currentType === +type
    },
    setSelected(type) {
      this.$emit('input', type)
    }
  }
}
</script>
